'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cookie = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _moment = require('moment/moment');

var _moment2 = _interopRequireDefault(_moment);

var _Cookie = require('../helpers/Cookie');

var _Cookie2 = _interopRequireDefault(_Cookie);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Cookie = exports.Cookie = function () {
  function Cookie() {
    (0, _classCallCheck3.default)(this, Cookie);
  }

  (0, _createClass3.default)(Cookie, null, [{
    key: 'getCookieName',
    value: function getCookieName(req, name, realm) {
      return (0, _Cookie2.default)(_config2.default.envPrefix, name, realm);
    }
  }, {
    key: 'saveSessionId',
    value: function saveSessionId(req, res, sessionId, realm, secure) {
      var sessionIdCookieName = Cookie.getCookieName(req, _Cookie.loginSessionIdName, realm);

      res.cookie(sessionIdCookieName, sessionId, {
        expires: new Date((0, _moment2.default)().add(2, 'years').toDate()),
        domain: (0, _Cookie.getCookieDomain)(),
        secure: secure,
        path: _Cookie.rootPath
      });
    }
  }, {
    key: 'migrateSessionId',
    value: function migrateSessionId(req, res, realm, secure) {
      var deprecatedSessionIdCookieName = Cookie.getCookieName(req, _Cookie.deprecatedSessionIdName, realm);

      if (deprecatedSessionIdCookieName in req.cookies) {
        var sessionId = req.cookies[deprecatedSessionIdCookieName];
        Cookie.saveSessionId(req, res, sessionId, realm, secure);
        res.clearCookie(deprecatedSessionIdCookieName, { path: _Cookie.rootPath });
      }
    }
  }, {
    key: 'clearSessionId',
    value: function clearSessionId(req, res, realm) {
      var deprecatedSessionIdCookieName = Cookie.getCookieName(req, _Cookie.deprecatedSessionIdName, realm);
      var sessionIdCookieName = Cookie.getCookieName(req, _Cookie.loginSessionIdName, realm);
      res.clearCookie(deprecatedSessionIdCookieName, { path: _Cookie.rootPath });
      res.clearCookie(sessionIdCookieName, { domain: (0, _Cookie.getCookieDomain)(), path: _Cookie.rootPath });
    }
  }, {
    key: 'getSessionId',
    value: function getSessionId(req, res, realm) {
      var deprecatedSessionIdCookieName = Cookie.getCookieName(req, _Cookie.deprecatedSessionIdName, realm);
      var sessionIdCookieName = Cookie.getCookieName(req, _Cookie.loginSessionIdName, realm);
      var sessionId = '';

      if (deprecatedSessionIdCookieName in req.cookies) {
        sessionId = req.cookies[deprecatedSessionIdCookieName];
      }

      if (sessionIdCookieName in req.cookies) {
        sessionId = req.cookies[sessionIdCookieName];
      }

      return sessionId;
    }
  }]);
  return Cookie;
}();


//////////////////
// WEBPACK FOOTER
// ./src/server/Cookie.js
// module id = 418
// module chunks = 0